// extracted by mini-css-extract-plugin
export default {"container":"AlertMessage_container__nP-5w","error":"AlertMessage_error__TYqha"};